import React, { forwardRef, useImperativeHandle, useRef } from "react";

import { ChipProps } from "./Chip.types";
import { StyledChip } from "./Chip.styles";

const Chip = forwardRef<HTMLDivElement, ChipProps>((props: ChipProps, ref) => {
    const {
        id = "",
        blockWidth = false,
        disabled = false,
        // elevation = false,
        leftNode = null,
        rightNode = null,
        size = "medium",
        onClick,
        children,
        padded = true,
        ...restProps
    } = props;

    const chipRef = useRef<HTMLDivElement>(null);
    useImperativeHandle(ref, () => chipRef.current!);

    return (
        <StyledChip
            {...restProps}
            ref={chipRef}
            id={id}
            blockWidth={blockWidth}
            disabled={disabled}
            // elevation={elevation}
            leftNode={leftNode}
            rightNode={rightNode}
            size={size}
            onClick={disabled ? undefined : onClick}
            padded={padded}
        >
            {leftNode} {children} {rightNode}
        </StyledChip>
    );
});

export default Chip;
